import {PurchaseOrderStatus} from '@/Types/Enums/PurchaseOrderStatus'
import {Color} from '@/Types/Enums/Color'

export const getPurchaseOrderColorByStatus = (status:PurchaseOrderStatus):Color => {
	if(status === PurchaseOrderStatus.Awaiting){
		return Color.Yellow
	}
	if(status === PurchaseOrderStatus.Pending){
		return Color.Orange
	}
	if(status === PurchaseOrderStatus.Accepted){
		return Color.Green
	}
	if(status === PurchaseOrderStatus.Rejected){
		return Color.Red
	}
	if(status === PurchaseOrderStatus.Expired){
		return Color.Rose
	}
	return Color.Neutral
}